import React from "react";
import { Navigate } from "react-router-dom";
import routes from "constants/routes";
import Unauthorized from "containers/Unauthorized/Unauthorized";
import { tokenUtils } from "utils";
import AppLayout from "components/AppLayout/AppLayout";

const AuthenticatedRoute = () => {
  const loggedIn = tokenUtils.isUserLoggedIn();
  const allowed = tokenUtils.isUserAllowed();

  if (!loggedIn) {
    return (
      <>
        <Navigate
          to={`${routes.login.root}?redirect=${window.location.pathname}`}
          replace
        />
      </>
    );
  }

  if (!allowed) {
    return <Unauthorized variant="inPlace" />;
  }


  if (!allowed) {
    return <Unauthorized variant="inPlace" />;
  }


  return <AppLayout />;
};

export default AuthenticatedRoute;
